import AppShell from "@/components/shell/AppShell";

const CollabLayout = () => <AppShell />;

export default CollabLayout;
